import { Component } from 'react';
import PropTypes from 'prop-types';
import Select from './select';

class RequiredSelect extends Component {
  render() {
    return (
      <Select {...this.props} required />
    );
  }
}

RequiredSelect.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  values: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object]).isRequired,
  labelAttr: PropTypes.string,
  valueAttr: PropTypes.string,
  disabled: PropTypes.bool,
  hasEmptyValue: PropTypes.bool,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
};

RequiredSelect.defaultProps = {
  hasEmptyValue: true,
  labelAttr: 'label',
  valueAttr: 'value',
  disabled: false,
  controlId: Math.random().toString(16).substring(2),
  errorLabel: 'error',
};

export default RequiredSelect;
